import { tailwind } from '@theme-ui/presets'
export default {
    ...tailwind,
    styles: {
        ...tailwind.styles,
    },
    colors: {
        text: `white`,
        background: `black`,
        primary: `red`,
        secondary: `magenta`,
    },
}
